import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const simpleButton: ThemeUICSSObject = {
  display: 'inline-flex',
  gap: spacing(3),
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',

  '.toggled': {
    backgroundColor: 'primary',
  },
  /* PREPEND HERE */
};

export default simpleButton;
